import './App.css';
import AppRoutes from './components/routes/AppRoutes';
import { AuthProvider } from './AuthContext';

import { YearProvider } from './api/context/YearContext';

import { BrowserRouter as Router } from 'react-router-dom';
import { useEffect } from 'react';
import { getDeviceToken, onMessageListener } from './firebase/firebase';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  useEffect(() => {
    let touchStartY = 0;
    let isPreventing = false;

    const handleTouchStart = (e) => {
      touchStartY = e.touches[0].clientY;
    };

    const handleTouchMove = (e) => {
      const touchY = e.touches[0].clientY;
      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (scrollTop <= 0 && touchY > touchStartY + 5) {
        if (!isPreventing) {
          isPreventing = true;
          e.preventDefault();
        }
      } else {
        isPreventing = false;
      }
    };

    document.addEventListener('touchstart', handleTouchStart, { passive: true });
    document.addEventListener('touchmove', handleTouchMove, { passive: false });

    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchmove', handleTouchMove);
    };
  }, []);

  // -----------------------------
  // Register device token & foreground notifications
  // -----------------------------
  useEffect(() => {
    // Register device token
    getDeviceToken().then(token => {
      if (token) {
        fetch('/notifications/save-device-token/', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('access')}`
          },
          body: JSON.stringify({ token })
        });
      }
    });

    // Listen for foreground messages
    onMessageListener(payload => {
      const { title, body } = payload.notification;
      const url = payload.data?.url || "/";
      toast.info(`${title}: ${body}`, {
        position: "top-right",
        autoClose: 5000,
        onClick: () => window.open(url, "_blank")
      });
    });
  }, []);

  return (
    <div className="App">
      <YearProvider>
      <AuthProvider>
      
          <Router>
            <AppRoutes />
          </Router>
        
      </AuthProvider>
      <ToastContainer /> {/* Toast notifications container */}
      </YearProvider>
    </div>
  );
}

export default App;
